<div class="driver-central-modal">
  <mat-dialog-actions>
    <div class="dialog-close">
      <i mat-dialog-close class="fas fa-times" (click)="closeDialog()"></i>
    </div>
    <div mat-dialog-title>Driver Central</div>
  </mat-dialog-actions>

  <mat-dialog-content>
    <div class="content">
      <div class="row-item">
        <div class="title">Summary</div>
        <hr />
        <div class="summary-table">
          <div class="table-row">
            <div class="label">Form Type</div>
            <div class="value">{{ formType }}</div>
            <div class="label">Coach</div>
            <div class="value">{{ coach }}</div>
          </div>
          <hr class="row-separator" />
          <div class="table-row">
            <div class="label">Topic</div>
            <div class="value">{{ topic }}</div>
            <div class="label">Creation Date</div>
            <div class="value">{{ creationDate }}</div>
          </div>
        </div>
        <hr />
      </div>

      <div class="details-section">
        <div class="title">Details</div>
        <div *ngIf="isLoading" class="spinner-container">
          <mat-progress-spinner
            mode="indeterminate"
            [diameter]="30"
            class="spinner"
          ></mat-progress-spinner>
        </div>
        <div *ngIf="!isLoading">
          <div *ngFor="let detail of detailFields" class="detail-item">
            <div class="detail-label">{{ detail.label }}</div>
            <div class="detail-value">{{ detail.value }}</div>
          </div>
          <div *ngIf="detailFields.length === 0" class="no-details">
            No details available for this record.
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
